import { GET_PROFILE } from "../actions/actionTypes"

const initialState = {
  profile: {},
  hasProfile: false
}


export default function(state=initialState, action){
  switch(action.type){

    case GET_PROFILE:
      return{
        ...state,
        profile: action.payload,
        hasProfile: true
      }

    default:
        return state
  }
}